/**
 * Hash helper for the device PIN. Uses SubtleCrypto when available (HTTPS or
 * localhost). In insecure LAN contexts SubtleCrypto is missing, so a plain
 * FNV-style digest keeps the prototype working — clearly not for production,
 * where the PIN only ever protects a local session token anyway.
 */
export async function hashString(input: string, salt = 'edry-prototype'): Promise<string> {
  const data = `${salt}:${input}`;
  try {
    const subtle = globalThis.crypto?.subtle;
    if (subtle) {
      const buf = await subtle.digest('SHA-256', new TextEncoder().encode(data));
      return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');
    }
  } catch {
    /* fall through */
  }
  let h = 0x811c9dc5;
  for (let i = 0; i < data.length; i++) h = Math.imul(h ^ data.charCodeAt(i), 16777619) >>> 0;
  return `weak-${h.toString(16)}`;
}
